<template>
  <div id="ml">
    <div class="content-row"  > <!-- @click="goDown" -->
      <div class="content-n-row" style="color:red;">
        播放样片 : {{ courseContent.courseName }}
      </div>
      <div class="dist-list" >
        <!--  @click="playPause(isPlay)" -->
          <img class="dist-list-img"  @click="playPause()" style="float:right;width: .34rem;height: .34rem;margin-right: .4rem;margin-top: -0.2rem;" 
          :src="img"/>
      </div>
      <div class="content-n-row article">
        {{courseContent.shareVideoDuration || '努力计算中...'}}
      </div>
    </div>
    <div class="dist" @click="goDown" v-for="item in courseCatalogue">
      <div class="dist-title" v-if="item.sections == null" >
         <div>{{item.title}}</div>
				 <div style="margin-top: 0.1rem;">{{ item.durationStr }}</div>
				 <img style="width: 0.34rem;	height: 0.34rem;position: absolute;top: 50%;right: 0.2rem;transform: translate(0,-50%);" class="dist-img"  src="../../../assets/img/video.png"/>
      </div>
			<div class="dist-title" v-else>
				<div>{{ item.indexName }} {{item.title}}</div>
			</div> 

      <div class="dist-list" v-for="(item1,index) in item.sections">
        <span class="dist-index">{{index+1}}</span>
        <span class="dist-content">{{item1.title}} </span>
        <span v-if="item1.title.length<16" class="dist-video video">
          <img  src="../../../assets/img/public-course/video.png"/>
        </span>
        <span v-else class="dist-video">
          <img  src="../../../assets/img/public-course/video.png"/>
        </span>
        <div class="dist-time">
          <!-- 试看状态 1试看 2不能试看 -->
          <span v-if="item1.trySeeStatus == 1" class="dist-time-button">试看 </span>
          <span class="dist-time-min"> {{item1.durationStr}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default{
        data:function(){
            return {
              img:require('../../../assets/img/public-course/video.png'),
              isPlay:false,//是否播放
              courseCatalogue1:[{
              title:'五星红旗', durationStr:'10', 
              indexName:'热烈庆祝中华人民成立70周年',
              sections:[{
                title:'中国国旗',trySeeStatus:1,
                durationStr:`本次演练是庆祝活动最后一次演练，包括庆祝大会仪式、阅兵、群众游行、联欢活动、转场及应急处置等6项内容，
                重点检验庆祝活动全流程、全要素、全力量的衔接配合，全面提升各方组织指挥和保障体系运行效能。各类参演、观礼及保障人员达30余万`
              }]
            }]
          }
        },
        props: {
          courseCatalogue:Array,
          courseContent:Array,
          bf:{
            type:Boolean,
            default(){
              return false;
            }
          },
          playerObj:{
            type:Object,
            default(){
              return Object
            }
          },
        },
        destroyed(){
          window.removeEventListener('popstate', this.fun, false);//false阻止默认事件
        },
        mounted:function(){
           //console.log(this.courseCatalogue);
           if (window.history && window.history.pushState) {
            history.pushState(null, null, document.URL);
            window.addEventListener('popstate', this.fun, false);//false阻止默认事件
          }
        },
				methods: {
          fun(){
            //alert("监听到了");
          },
					goDown() {
            this.$root.download();
          },
          playPause(){
            // this.$refs.videoPlayer.player.play()//播放
            // this.$refs.videoPlayer.player.pause();//暂停
            // this.$refs.videoPlayer.player.src(src);// 重置进度条
            //console.log(this.playerObj.player)
            console.log(this.playerOptions)
            if(!this.isPlay){
              this.isPlay = true;
              //this.img = require('../../../assets/img/public-course/pause.png')
              this.playerObj.player.play()
            }else{
              this.isPlay = false;
              //this.img = require('../../../assets/img/public-course/video.png')
              this.playerObj.player.pause()
            }
          }
				}
    }
</script>
<style lang="scss">
  .dist{
    // float: left;
		overflow: hidden;
    height: auto;
    width: 7rem;
    margin: .26rem auto;
    border-radius: 5px;
    box-shadow: 0 0 0.4rem #e3e1e1;
		z-index: 99999;
    .dist-title{
      float: left;
      text-align: left;
      width: 90%;
      font-size: .32rem;
      color: #000;
      padding: .34rem 0;
      border-bottom: 1px solid #f7f8fa;
      margin-left: 0.3rem;
			position: relative;
			
    }
		.dist-title div{
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
		}
    .dist-list{
      float: left;
      text-align: left;
      font-size: .3rem;
      width: 90%;

      padding: .34rem 0;
      border-bottom: 0.01333rem solid #f7f8fa;
      margin-left: 0.3rem;
      .dist-list-img{
        width: .34rem;
        height: .34rem;
        margin-right: .4rem;
        margin-top: -0.2rem;
      }
    }
    .dist-index{
      margin-top: 0.2rem;
      padding-right: .2rem;
          height: auto;
      float: left;
    }
    .dist-content{
      display: block;
      display: -webkit-box;
      line-height: .45rem;
      // height: .45rem;
      height: auto;
      width: 4.4rem;
			overflow: hidden;
			text-overflow: ellipsis;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
    }
    .dist-video{
      float: right;
      margin-right: .3rem;
      margin-top: -.5rem;
      & img{
        width: .34rem;
        height: .34rem;
      }
    }
    .video{
      margin-top: -.2rem;
    }
    .dist-time{
      margin-left: 0.3rem;
      .dist-time-button{
        font-size: .2rem;
        color: #FFA0A5;
        border: 1px solid;
        padding: .06rem .02rem .04rem .07rem;
        border-radius: 2px;
        
      }
      .dist-time-min{
        margin-left: 0.1rem;
        font-size: .26rem;
        color: #999;
      }
			.dist-img{
				
			}
    }
  }
</style>